<template lang="pug">
  nav.menu-top(v-if="items")
    .menu-top__left
        .menu-top__items
          .menu-top__item(v-for='item in items.navigation', :key="item.id")
              router-link.menu-top__item-link(:to="item.link") {{item.title}}
                  .menu-top__item-dividers
                      SvgIcon.menu-top__item-dividers-left(name="dividers-left" width="16" height="37")
                      .menu-top__item-dividers-line
                      SvgIcon.menu-top__item-dividers-right(name="dividers-right" width="16" height="37")
          .menu-top__item.menu-top__item--404
              router-link.menu-top__item-link(to="/*")
                  .menu-top__item-dividers
                      SvgIcon.menu-top__item-dividers-left(name="dividers-left" width="16" height="37")
                      .menu-top__item-dividers-line
                      SvgIcon.menu-top__item-dividers-right(name="dividers-right" width="16" height="37")
    .menu-top__right
        a.menu-top__right-item.menu-top__right-item--instagram(target="_blank" :href="items.icons[0].link")
            SvgIcon.menu-top__right-item-icon(:name="items.icons[0].name" width="20" height="29")
        a.menu-top__right-item.menu-top__right-item--vk(target="_blank" :href="items.icons[1].link")
            SvgIcon.menu-top__right-item-icon(:name="items.icons[1].name" width="22" height="30")
        a.menu-top__right-item.menu-top__right-item--facebook(target="_blank" :href="items.icons[2].link")
            SvgIcon.menu-top__right-item-icon(:name="items.icons[2].name" width="16" height="25")
</template>

<script>
  import '@/components/common/menuTop/menuTop.styl';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import EventBus from '@/eventBus';

  export default {
    name: 'MenuTop',
    components: {
        SvgIcon
    },

    data() {
        return {
            oldPath: null,
            update: false,
            audio: new Audio,
        }
    },

    props: {
      items: {
        type: Object,
        required: true,
        default: null
      },

      path: {
        type: String
      }
    },

    watch: {
      path(newVal, oldVal) {
        this.path = newVal;
        this.oldPath = oldVal;
        this.$nextTick(() => {
            if($(window).width() > 1200) {
                this.setActiveClass();
            } else  {
                this.setMobileActiveClass();
            }
        })
      }
    },

    created() {
        EventBus.$on('audioVolumeOff', () => {
            this.audio.volume = 0;
        });

        EventBus.$on('audioVolumeOn', () => {
            this.audio.volume = 0.2;
        });
    },

    methods: {
      setActiveClass() {
          $('.menu-top__items').css('pointer-events', 'none');
          if(!this.update) {
              this.audio.play().catch(() => {});
              this.update = true;
              let $newActive, $oldActive;
              let pathmenu = this.path.substr(1).split('/');
              let oldpathmenu = [null];
              if(this.oldPath && this.oldPath !=='/') {
                  oldpathmenu = this.oldPath.substr(1).split('/');
                  $oldActive = $(`.menu-top__items [href*='${oldpathmenu[0]}']`).parent();
                  if($oldActive.length === 0) {
                      $oldActive = $(`.menu-top__items [href='/*']`).parent();
                  }
              }
              else {
                  $oldActive = $(`.menu-top__items [href='${this.oldPath}']`).parent();
              }
              if (this.path.indexOf(pathmenu[0]) && this.path !== '') {
                  $newActive = $(`.menu-top__items [href*='${pathmenu[0]}']`).parent();

                  if($newActive.length === 0) {
                      $newActive = $(`.menu-top__items [href='/*']`).parent();
                  }
              }
              else {
                  $newActive = $(`.menu-top__items [href='${this.path}']`).parent();
              }
              if(this.path === '') {
                  $newActive = $(`.menu-top__items [href='${this.path}']`).parent();
              }
              if(oldpathmenu[0] !== pathmenu[0]) {
                  let width = $newActive.width();
                  let oldPosition = 0;
                  if($oldActive.length) {
                      oldPosition = $oldActive.position().left;
                  }
                  let newPosition = $newActive.position().left;
                  let position = newPosition - oldPosition;
                  $oldActive.find('.menu-top__item-dividers').width(width);
                  $oldActive.find('.menu-top__item-dividers').css('transform', 'translateX('+position+'px)');
                  setTimeout(() => {
                      $newActive.addClass('menu-top__item-link--active');
                  }, 300);
                  setTimeout(() => {
                      $oldActive.removeClass('menu-top__item-link--active');
                      $oldActive.find('.menu-top__item-dividers').css({'width': '100%', 'transform': 'translateX(0)'});
                      this.update = false;
                      $('.menu-top__items').css('pointer-events', 'painted');
                  }, 600);
              } else {
                  this.update = false;
                  $('.menu-top__items').css('pointer-events', 'painted');
              }
          }
      },

      setMobileActiveClass(params) {
          $('.menu-top__item').removeClass('menu-top__item-link--active');
          let pathmenu = this.path.substr(1).split('/');
          let $active;
          if (this.path.indexOf(pathmenu[0]) && this.path !== '') {
              $active = $(`.menu-top__items [href*='${pathmenu[0]}']`).parent();

              if($active.length === 0) {
                  $active = $(`.menu-top__items [href='/*']`).parent();
              }
          }
          else {
              $active = $(`.menu-top__items [href='${this.path}']`).parent();
          }
          if(this.path === '') {
              $active = $(`.menu-top__items [href='${this.path}']`).parent();
          }
          $active.addClass('menu-top__item-link--active');
          if(!params) {
              setTimeout(() => {
                  $('.header__burger').removeClass('header__burger--open');
                  $('.header__mobile').removeClass('header__mobile--show');
                  setTimeout(() => {
                      $('.header').removeClass('header--height');
                  }, 200);
              }, 200);
          }
      },

      audioInit() {
          this.audio.src = '/music/ringing.wav';
          this.audio.volume = 0.2;
      },
    },

    mounted() {
      this.$nextTick(() => {
          if($(window).width() > 1200) {
              this.setActiveClass();
              this.audioInit();
          } else  {
              this.setMobileActiveClass('first-load');
          }
      });
    }
  }
</script>
